import { Link, useLocation } from "react-router-dom";

const labelMap: Record<string, string> = {
  admin: "Admin",
  quotations: "Quotations",
  products: "Products",
  panels: "Glass Panels",
  attachments: "Attachments",
  stores: "Stores",
  bugs: "Bug Reports",
};

const Breadcrumb = () => {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) return null;

  return (
    <nav className="page-breadcrumb" aria-label="Breadcrumb">
      {segments.map((segment, index) => {
        const path = "/" + segments.slice(0, index + 1).join("/");
        const label = labelMap[segment] || segment;
        const isLast = index === segments.length - 1;

        if (isLast) {
          return (
            <span key={path} className="breadcrumb-current">
              {label}
            </span>
          );
        }

        return (
          <span key={path}>
            <Link to={path}>{label}</Link>
            <span className="breadcrumb-separator"> / </span>
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
